import { Link } from "react-router-dom";

export default function PostCard({ post }) {
  return (
    <article className="bg-white rounded-xl shadow-sm hover:shadow-md transition-shadow border border-gray-100 overflow-hidden">
      <Link to={`/blog/${post.slug}`} className="block">
        <div className="relative">
        <img
        src={post.cover.src}
        alt={post.cover.alt}
        loading="lazy"
        decoding="async"
        referrerPolicy="no-referrer"
        width="1600"
        height="900"
        className="w-full h-56 object-cover"
        onError={(e) => {
            if (post.cover?.local && e.currentTarget.src !== post.cover.local) {
            e.currentTarget.src = post.cover.local; // use local fallback
            }
        }}
        />

        </div>
        <div className="p-5">
          <span className="inline-block text-xs font-semibold tracking-wider uppercase text-[#002B5C] bg-[#e8f1fb] px-3 py-1 rounded-full">
            {post.category}
          </span>
          <h3 className="mt-3 text-lg font-bold text-gray-900">{post.title}</h3>
          <p className="mt-2 text-gray-600 line-clamp-3">{post.excerpt}</p>
          <div className="mt-4 text-sm text-gray-500 flex items-center gap-3">
            <span>{new Date(post.date).toLocaleDateString()}</span>
            <span>•</span>
            <span>{post.readTime} min read</span>
          </div>
        </div>
      </Link>
    </article>
  );
}
